import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-company",
  "use": "icon-company-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-company\"><path d=\"M32 928v-64h64v-640a128 128 0 0 1 128-128h320a128 128 0 0 1 128 128v192h128a128 128 0 0 1 128 128v320h64v64H32z m576-704a64 64 0 0 0-64-64h-320a64 64 0 0 0-64 64v640h448v-640z m256 320a64 64 0 0 0-64-64h-128v384h192v-320z m-640 0h256v64h-256v-64z m0-128h256v64h-256v-64z m0-128h256v64h-256v-64z\" p-id=\"13599\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/company.svg
// module id = znPN
// module chunks = 36